import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import { useModal } from 'store/modals';
import { useDeleteTimeProfile } from 'services/2n/time-profiles';
import { DeleteButton } from 'components/form-elements/buttons/DeleteButton';
import { useAccessManagement2NModal } from '../../../AccessManagement2NModalContext/useAccessManagement2NModal';

export const DeleteTimeProfile = () => {

  const intl = useIntl();
  const { openModal } = useModal();
  const { selected, updateSelected } = useAccessManagement2NModal();
  const selectedTimeProfile = selected.timeProfile;
  const { mutateAsync: deleteTimeProfile, isLoading } = useDeleteTimeProfile();

  function onDeleteTimeProfile() {

    const selectedTimeProfileId = selectedTimeProfile && selectedTimeProfile.Id;
    if (!selectedTimeProfileId) return;

    openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        title: intl.formatMessage(
          {
            id: 'deleteTimeProfileConfirm',
          },
        ),
        content: intl.formatMessage(
          {
            id: 'deleteTimeProfileConfirmContent',
          },
        ),
        onConfirm: async () => {
          await deleteTimeProfile(selectedTimeProfileId);
          updateSelected('timeProfile', null);
        },
      },
    });
  }

  return (

    <DeleteButton
      intl="deleteTimeProfilePermanently"
      onClick={() => onDeleteTimeProfile()}
      disabled={!selectedTimeProfile || isLoading}
    >
      <FormattedMessage id="deleteTimeProfilePermanently" />
    </DeleteButton>
   
  );
};

